import { render, staticRenderFns } from "./PointsSection.vue?vue&type=template&id=f9838418"
import script from "./PointsSection.vue?vue&type=script&lang=js"
export * from "./PointsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports